import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link, useNavigate } from "react-router-dom";
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signOut } from "firebase/auth";

import StockForm from "./Component/stockForm";
import DisplayTransactions from "./Component/display";
import EditStockForm from "./Component/EditForm";
import Partnership from "./Component/Partnership";
import Home from "./Component/Home"; // ✅ Import Home page

import "./App.css";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      setUser(result.user);
    } catch (error) {
      console.error("Error during Google sign-in", error);
    }
  };

  const handleLogout = () => {
    signOut(auth).then(() => {
      setUser(null);
    });
  };

  const PrivateRoute = ({ children }) => {
    const navigate = useNavigate();

    useEffect(() => {
      if (!loading && (!user || user.email !== "ks511658@gmail.com")) {
        navigate("/");
      }
    }, [loading, user, navigate]);

    if (loading) return <div>Loading...</div>;

    return user && user.email === "ks511658@gmail.com" ? children : null;
  };

  return (
    <Router>
      <div className="App">

        <header className="header">
          <h3>Stock Market Transactions</h3>

          <nav>
            <ul className="nav-links">
              <li>
                <Link to="/">Home</Link>
              </li>

              {/* Trades Section */}
              <li>
                <Link to="/trades">Trades</Link>
              </li>

              <li>
                <Link to="/entry">Entry</Link>
              </li>

              <li>
                <Link to="/edit">Edit</Link>
              </li>

              <li>
                <Link to="/partnership">Partnership</Link>
              </li>

              {user ? (
                <li>
                  <button onClick={handleLogout}>Logout</button>
                </li>
              ) : (
                <li>
                  <button onClick={handleGoogleSignIn}>Login with Google</button>
                </li>
              )}
            </ul>
          </nav>
        </header>

        <Routes>

          {/* ✅ Home page first */}
          <Route path="/" element={<Home />} />

          {/* ✅ Trades page */}
          <Route path="/trades" element={<DisplayTransactions />} />

          <Route
            path="/entry"
            element={
              <PrivateRoute>
                <StockForm />
              </PrivateRoute>
            }
          />

          <Route
            path="/edit"
            element={
              <PrivateRoute>
                <EditStockForm />
              </PrivateRoute>
            }
          />

          <Route path="/partnership" element={<Partnership />} />

        </Routes>

      </div>
    </Router>
  );
}

export default App;